class Attributes {
  getAttribute(name, value) {
    let nameData = '';
    let valueData = '';
    if (name) {
      nameData = name;
    }
    if (value) {
      valueData = value;
    }
    return {name: nameData, value: valueData};
  }
  
  getAttributes(attributeList) {
    let dataList = [];
    if (attributeList) {
      dataList = attributeList;
    }
    
    return {
      attributes: dataList,
    };
  }
}

export default new Attributes();
